var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","line-height":"60px","height":"100%"}},[_vm._v(" xxx公司 ")])}
var staticRenderFns = []

export { render, staticRenderFns }